module.exports = __webpack_public_path__ + "angular-development.2qEi-8m8.svg";